import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";

import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-calendar/dist/Calendar.css";
import Themes from "./themes";
import { SearchProvider } from "./context/SearchContext";

import { Provider } from "react-redux";
import store from "./store";

if (process.env.NODE_ENV !== "production") {
  localStorage.setItem("debug", "titan-app:*");
}

ReactDOM.render(
  <LayoutProvider>
    <UserProvider>
      <SearchProvider>
        <ThemeProvider theme={Themes.default}>
          <CssBaseline />
          <Provider store={store}>
            <App />
          </Provider>
        </ThemeProvider>
      </SearchProvider>
    </UserProvider>
  </LayoutProvider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
